import { render } from "./QuestionCard.vue?vue&type=template&id=33b63ba7"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=33b63ba7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__